import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable, inject } from '@angular/core';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';
import type { GetWoodCertificationsInputDto, WoodCertificationCreateDto, WoodCertificationDto, WoodCertificationExcelDownloadDto, WoodCertificationUpdateDto } from '../dtos/wood-certification/models';

@Injectable({
  providedIn: 'root',
})
export class WoodCertificationService {
  private restService = inject(RestService);
  apiName = 'Geographic';
  

  create = (input: WoodCertificationCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WoodCertificationDto>({
      method: 'POST',
      url: '/api/geographic/woodCertifications',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/geographic/woodCertifications/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/geographic/woodCertifications',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WoodCertificationDto>({
      method: 'GET',
      url: `/api/geographic/woodCertifications/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/geographic/woodCertifications/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetWoodCertificationsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<WoodCertificationDto>>({
      method: 'GET',
      url: '/api/geographic/woodCertifications',
      params: { certificationTypeId: input.certificationTypeId, managementTypeId: input.managementTypeId, certificationLevelId: input.certificationLevelId, certificateTypeId: input.certificateTypeId, woodStatementId: input.woodStatementId, initialArea: input.initialArea, initialAreaFrom: input.initialAreaFrom, initialAreaTo: input.initialAreaTo, certificationCode: input.certificationCode, certificatorId: input.certificatorId, startDate: input.startDate, startDateFrom: input.startDateFrom, startDateTo: input.startDateTo, finishDate: input.finishDate, finishDateFrom: input.finishDateFrom, finishDateTo: input.finishDateTo, notes: input.notes, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: WoodCertificationExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/geographic/woodCertifications/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, certificationTypeId: input.certificationTypeId, managementTypeId: input.managementTypeId, certificationLevelId: input.certificationLevelId, certificateTypeId: input.certificateTypeId, woodStatementId: input.woodStatementId, initialArea: input.initialArea, initialAreaFrom: input.initialAreaFrom, initialAreaTo: input.initialAreaTo, certificationCode: input.certificationCode, certificatorId: input.certificatorId, startDate: input.startDate, startDateFrom: input.startDateFrom, startDateTo: input.startDateTo, finishDate: input.finishDate, finishDateFrom: input.finishDateFrom, finishDateTo: input.finishDateTo, notes: input.notes, isCursorPaging: input.isCursorPaging, includeTotalCount: input.includeTotalCount, id: input.id, idFrom: input.idFrom, idTo: input.idTo, creationTime: input.creationTime, creationTimeFrom: input.creationTimeFrom, creationTimeTo: input.creationTimeTo, creatorId: input.creatorId, lastModificationTime: input.lastModificationTime, lastModificationTimeFrom: input.lastModificationTimeFrom, lastModificationTimeTo: input.lastModificationTimeTo, lastModifierId: input.lastModifierId, deletionTime: input.deletionTime, deletionTimeFrom: input.deletionTimeFrom, deletionTimeTo: input.deletionTimeTo, deleterId: input.deleterId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WoodCertificationDto[]>({
      method: 'GET',
      url: '/api/geographic/woodCertifications/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: WoodCertificationUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, WoodCertificationDto>({
      method: 'PUT',
      url: `/api/geographic/woodCertifications/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });
}